module.exports = __webpack_public_path__ + "img/img1.311a257f.jpg";